import React from 'react';

import classNames from 'classnames';

import { useAppSelector } from 'store/hook';
import { SelectAdvancedFilterOptionType } from 'types/common';
import { CompanyType } from 'types/company';

import { useCommunitiesContext } from './CommunitiesContext';
import SelectAdvancedFilter from '../lib/SelectAdvancedFilter';

const CommunitiesControlsFiltersCompany = () => {
  const { companies } = useAppSelector((state) => state.global);
  const { filters, setFilters } = useCommunitiesContext();

  const companyOptions = companies?.map((company: CompanyType) => ({
    label: company.name,
    value: company.id,
  }));

  const handleSelectCompany = (values: SelectAdvancedFilterOptionType[]) => {
    const selection = (values ?? []).map((item: SelectAdvancedFilterOptionType) => item.value);
    setFilters({ ...filters, company: selection });
  };

  return (
    <SelectAdvancedFilter
      className={classNames({ active: filters?.company && filters.company.length > 0 })}
      placeholder={'Company'}
      options={companyOptions}
      defaultValue={filters?.company ?? []}
      onSelect={handleSelectCompany}
    />
  );
};

export default CommunitiesControlsFiltersCompany;
